import React from "react";
import axios from "services/axios";
import { Button, Card, message, Spin, Tooltip, Tag } from "antd";
import MUIDataTable from "mui-datatables";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import momentTZ from "moment-timezone";
import _ from "lodash";
class NewCarInProgress extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newCar: [],
      isLoading: true,
      confirmLoading: false,
      disableButton: true,
      openModal: false,
      fileList: null,
      page: 1,
      limit: 15,
      count: 0,
      search: "",
      sort: { name: "date", direction: "desc" },
    };
  }

  componentDidMount() {
    this.fetchNewCar(this.state.page, this.state.limit);
  }

  orderBy(sort) {
    let key = "date";
    let value = "DESC";

    //Get Key
    if (sort.name === "Car Type") key = "carName";
    else if (sort.name === "Kepala Cabang") key = "kacab";
    else if (sort.name === "Tanggal Buat") key = "date";

    //Get Value
    if (sort.direction === "asc") value = "ASC";
    else if (sort.direction === "desc") value = "DESC";

    return `${key}=${value}`;
  }

  async fetchNewCar(page, limit) {
    const order = this.orderBy(this.state.sort);
    const query = `${order}&&page=${page}&&limit=${limit}&&search=${
      this.state.search || ""
    }`;
    const data = await axios
      .get(`admin-panel/new-car/new-approval?${query}`)
      .then(result => {
        this.setState({
          newCar: result.data.ApprovalNewCar,
          page: result.data.page,
          limit: result.data.limit,
          count: result.data.count,
          isLoading: false,
        });
      })
      .catch(err => {
        message.error("Gagal request data new car");
        this.setState({ isLoading: false });
      });
  }

  formatStatus(status) {
    switch (status) {
      case "Deal":
        return <Tag color="green">Deal</Tag>;
      case "No Deal":
        return <Tag color="magenta">No Deal</Tag>;
      default:
        return <Tag color="blue">New Approval</Tag>;
    }
  }

  changePage(page, limit) {
    this.setState({ isLoading: true });
    this.fetchNewCar(page, limit);
  }

  formatRupiah(number) {
    const data = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return data;
  }

  getMuiTheme = () =>
    createMuiTheme({
      typography: {
        useNextVariants: true,
      },
      overrides: {
        MUIDataTableBodyCell: {
          root: {
            "white-space": "nowrap",
            "&:nth-child(1)": {
              width: "8em",
              "min-width": "8em",
              "max-width": "8em",
              "word-break": "break-all",
            },
          },
        },
      },
    });

  render() {
    //Columns
    const columns = [
      {
        name: "Action",
        options: {
          sort: false,
        },
      },
      {
        name: "Status",
        options: {
          sort: false,
        },
      },
      {
        name: "No New Car",
        options: {
          sort: false,
        },
      },
      {
        name: "Car Type",
        options: {
          sort: true,
        },
      },
      {
        name: "Kepala Cabang",
        options: {
          sort: true,
        },
      },
      {
        name: "Cabang",
        options: {
          sort: false,
        },
      },
      {
        name: "Tanggal Buat",
        options: {
          sort: true,
        },
      },
    ];

    //Data New Car
    const newCar = this.state.newCar.map((item, idx) => {
      return [
        <Link
          to={{
            pathname: `/home/approval/new-car-in-progress/${item.id}`,
            query: { status: "progress" },
          }}>
          <Tooltip placement="bottom" title="Detail Trade In">
            <Button icon="bars" style={{ marginRight: 10 }} />
          </Tooltip>
        </Link>,
        this.formatStatus(item.approvalStatus),
        item.noNewCar,
        item.NewCar.carName,
        item.SalesBranch.BranchHead.name,
        item.SalesBranch.branch,
        momentTZ(item.createdAt)
          .tz("Asia/Jakarta")
          .format("dddd, D MMMM YYYY HH:mm"),
      ];
    });

    //Options
    const options = {
      filter: false,
      responsive: "simple",
      fixedHeader: true,
      tableBodyHeight: "460px",
      print: false,
      selectableRows: "none",
      // resizableColumns: true,
      download: false,
      viewColumns: false,
      serverSide: true,
      rowsPerPage: this.state.limit,
      count: this.state.count,
      page: this.state.page - 1,
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.changePage(tableState.page + 1, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.changePage(1, tableState.rowsPerPage);
            break;
          case "search":
            this.setState({ search: tableState.searchText }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          case "sort":
            this.setState({ sort: tableState.sortOrder }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          default:
            console.log(action);
        }
      },
    };

    return (
      <Card
        title="List New Car Dalam Proses"
        style={{
          marginTop: 35,
          background: "#fff",
          minHeight: 360,
        }}>
        {/* <div style={{marginBottom: 10}}>
                    <Button onClick={() => this.downloadData()}>
                        Download Data
                    </Button>
                    
                    <Button onClick={() => this.openModal()} style={{ marginLeft: 10 }}>
                        Upload Data
                    </Button>
                </div> */}

        <Spin size="large" spinning={this.state.isLoading} tip="Loading...">
          <MuiThemeProvider theme={this.getMuiTheme()}>
            <MUIDataTable
              title="List New Car Dalam Proses"
              data={newCar}
              columns={columns}
              options={options}
            />
          </MuiThemeProvider>
        </Spin>
      </Card>
    );
  }
}

export default NewCarInProgress;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/NewCar/InProgress/NewCar.js